import { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { HiChevronDown, HiChevronRight } from 'react-icons/hi';
import { FormattedMessage } from 'react-intl';

import Button from '../Button';
import Card from '../Card';
import { DeviceTypes } from '../DeviceTypeSelection/DeviceTypeSelection';
import Transition from '../Transition';

import LightpadInfoImage from './lightpad_info_compressed.svg?react';
import NeoInfoImage from './neo_info_compressed.svg?react';

function InfoWrapper({ deviceType }: { deviceType: DeviceTypes }) {
  const [isToggled, setIsToggled] = useState(false);
  return (
    <Card className="items-start flex-col">
      <Button
        id="qrcode-toggle"
        className="flex w-full items-center text-lg"
        onClick={() => setIsToggled(!isToggled)}
      >
        {isToggled ? (
          <HiChevronDown className="h-5 w-5" />
        ) : (
          <HiChevronRight className="h-5 w-5" />
        )}
        <div className="flex grow items-center px-2 gap-2">
          <FaInfoCircle className="h-4 w-4" />
          <FormattedMessage id="Instructions" />
        </div>
      </Button>
      <Transition show={isToggled} className="flex justify-center w-full">
        {deviceType === DeviceTypes.LIGHTPAD ? (
          <LightpadInfoImage className="max-w-xl w-full" />
        ) : (
          <NeoInfoImage className="max-w-xl w-full" />
        )}
      </Transition>
    </Card>
  );
}
export default InfoWrapper;
